import { createSafeContentWithData } from "@/libs/builder/tools/createSafeContentWithData/createSafeContentWithData";

const { Content, createDefaultDataBindings } = createSafeContentWithData<{
  categoryName: string;
  categoryItems: {
    name: string;
    sku: string;
    url_key: string;
    thumbnailSrc: string;
    shortDescription?: string;
  }[];
  categoryFilters: {
    productCount: number;
    name: string;
    uid: string;
    checked: boolean;
  }[];
}>();

export { Content, createDefaultDataBindings };
